import type { OptionState } from '@openx/types/options.ts';
import { useMemo } from 'react';
import { useOptionsByPathQuery } from '../../../../hooks/useOptionsByPathQuery.ts';
import { toList } from '../toList.ts';
import { toMapById } from '../toMapById.ts';

export const useOldAdPlacementOptionsFetch = (): OptionState => {
  const {
    data: { optionsByPath = [] } = {},
    loading,
    refetch,
  } = useOptionsByPathQuery({
    variables: {
      path: 'deal.package.targeting.inventory_format.ad_placement',
    },
  });

  const list = useMemo(() => toList(optionsByPath), [optionsByPath]);
  const mapById = useMemo(() => toMapById(list), [list]);

  return {
    list,
    loading,
    mapById,
    refetch,
  };
};
